// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ut-Si","location":"Header_location__1LSyH"};